import { TranslationKey, useI18n } from "../../../shared/i18n/i18n";

type AdminRoutePlaceholderProps = {
  titleKey: TranslationKey;
  descriptionKey?: TranslationKey;
};

export const AdminRoutePlaceholder = ({ descriptionKey, titleKey }: AdminRoutePlaceholderProps) => {
  const { t } = useI18n();
  return (
    <section className="admin-shell-right-pane">
      <div className="admin-route-placeholder">
        <p className="admin-route-placeholder-eyebrow">{t("admin.route.placeholder.eyebrow")}</p>
        <h2 className="admin-route-placeholder-title">{t(titleKey)}</h2>
        {descriptionKey ? (
          <p className="admin-route-placeholder-description">{t(descriptionKey)}</p>
        ) : null}
      </div>
    </section>
  );
};
